import {
    Button,
    Card,
    Grid,
    InputAdornment,
    Table,
    TableContainer,
    TableHead,
    TextField,
    Typography,
    TableRow,
    TableBody,
    Box,
    TablePagination,
    Divider,
    FormControl,
    Select,
    MenuItem,
    Tooltip,
    ListSubheader,
    IconButton,
    ListItemText,
    Checkbox,
    Autocomplete,
    Chip
} from '@mui/material';
import { ChangeEvent, useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { AppActions } from 'src/store/AppReducer';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import { withStyles } from '@mui/styles';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import { TableColumnCell } from 'src/components/TableColumnCell';
import EditIcon from '@mui/icons-material/Edit';
import ChecklistIcon from '@mui/icons-material/Checklist';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import { DateRangePicker } from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment';
import SnackBar from 'src/components/SnackBar/SnackBar';
import { getCandidates,getCandidateById,getTaskList,downloadCandidatesReport } from "src/services/onboardingService";

import { validateMultiRolesAndPermissions } from "src/utils/validate";
import { getRolePermissions } from "src/services/authService";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DownloadIcon from '@mui/icons-material/Download';
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

import {getAllBillingRoles} from 'src/services/employeeService';
import CandidateForm from './candidate/CandidateForm';
import React from 'react';
import Multiselect from 'multiselect-react-dropdown';

export enum CandidateStatus {
    PENDING = 'Pending',
    IN_PROGRESS = 'In Progress',
    COMPLETED = 'Completed'
}

export enum TaskStatus {
    TO_DO = 'To Do',
    ON_HOLD = 'On Hold',
    IN_PROGRESS = 'In progress',
    COMPLETED = 'Completed'
}


const ViewOnboarding = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const joinDateRef = useRef<any>(null);
    const onboardingDateRef = useRef<any>(null);
    const [candidates, setCandidates] = useState([]);
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState('');
    const [snackBarMessage, setSnackBarMessage] = useState('');
    const [searchString, setSearchString] = useState('');
    const [toggleFilter, setToggleFilter] = useState(false);
    const [recordCount, setRecordCount] = useState<number>(0);
    const [filterDesignation, setFilterDesignation] = useState('');
    const [filterStatus, setFilterStatus] = useState('');
    const [sortBy, setSortBy] = useState('');
    const [sortValue, setSortValue] = useState('');
    const [page, setPage] = useState<number>(0);
    const [limit, setLimit] = useState<number>(10);
    const [designationList, setDesignationList] = useState([]);
    const [taskList, setTaskList] = useState([]);
    const [selectedTaskList, setSelectedTaskList] = useState<any[]>([]);
    const [resetKey, setResetKey] = useState(0);
    const [open, setOpen] = useState(false);
    const [permissions, setPermissions] = useState([]);
    const [isFilterDisabled, setIsFilterDisabled] = useState(true);
    const [isFilterCleared, setIsFilterCleared] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [filterStartJoinDate, setFilterStartJoinDate] = useState('');
    const [filterEndJoinDate, setFilterEndJoinDate] = useState('');
    const [filterJoinDateChanged, setFilterJoinDateChanged] = useState(false);
    const [filterStartOnboardingDate, setFilterStartOnboardingDate] = useState('');
    const [filterEndOnboardingDate, setFilterEndOnboardingDate] = useState('');
    const [filterOnboardingDateChanged, setFilterOnboardingDateChanged] = useState(false);
    const [formOpen, setFormOpen] = useState(false);
    const [formMode, setFormMode] = useState<'create' | 'edit' | 'view'>('create');
    const [selectedCandidate, setSelectedCandidate] = useState<any>(undefined);
    const [shouldOpenForm, setShouldOpenForm] = useState(false);
    const [filterSelectedTasks, setFilterSelectedTasks] = useState<string[]>([]);
    const [expandedCandidateId, setExpandedCandidateId] = useState('');
    const [expandedTaskId, setExpandedTaskId] = useState('');
    const [sortType, setSortType] = useState('asc');
    
    const parseDate = (dateStr?: string) => {
        if (!dateStr) return undefined;
        const m = moment(dateStr.trim(), "DD/MM/YYYY", true);
        return m.isValid() ? m.toDate() : undefined;
    };

const NavigateToToDoListPage = (candidateId: number) => {
  navigate(`/employee-onboarding/todo/${candidateId}`);
};



const handleViewCandidate = async (candidateId: number) => {
    try {
        dispatch(AppActions.showLoader());
        
        // Close form and reset state
        setFormOpen(false);
        setSelectedCandidate(undefined);
        setShouldOpenForm(false);
        
        const response = await getCandidateById(candidateId);
        
        if (response?.data?.statusCode === 200) {
            // Set data and trigger form opening
            setSelectedCandidate(response.data.data);
            setFormMode('view');
            setShouldOpenForm(true);
        } else {
            handleSnackbarMessage('Failed to load candidate details', 'error');
        }
    } catch (error) {
        handleSnackbarMessage('Failed to load candidate details', 'error');
    } finally {
        dispatch(AppActions.hideLoader());
    }
};

  const handleCreateCandidate = () => {
    // Reset form state before opening create mode
    setFormOpen(false);
    setSelectedCandidate(undefined);
    
    // Small delay to ensure form is properly reset
    setTimeout(() => {
        setFormMode('create');
        setFormOpen(true);
    }, 100);
};
const handleFormSuccess = (message?: string) => {
    getCandidateList(); // Refresh the candidates list

    // Use the message from CandidateForm if provided
    handleSnackbarMessage(
        message ||
        (formMode === 'edit'
            ? 'Candidate updated successfully'
            : 'Candidate added successfully'),
        'success'
    );

    // Close the form and reset state
    setFormOpen(false);
    setSelectedCandidate(undefined);

    // Reset form mode after a delay
    setTimeout(() => {
        setFormMode('create');
    }, 100);
};
    const handleFormError = (error: string) => {
        handleSnackbarMessage(error || 'Failed to save candidate', 'error');
    };


    const handleSnackbarMessage = (message: string, severity: 'success' | 'error' | 'warning' | 'info') => {
        setSnackBarMessage(message);
        setSnackbarSeverity(severity);
        setSnackBarOpen(true);
    };

    const filteredDesignations = designationList.filter((item) =>
        item.name.toLowerCase().includes(searchText.toLowerCase())
    );

    const getPermissions = (mail) => {
        getRolePermissions(mail)
            .then((res) => {
                const tabs = validateMultiRolesAndPermissions(res);
                const arr = tabs.filter((fil) => fil.name === 'Employee Onboarding');

                if (arr.length > 0) {
                    setPermissions(arr.length > 0 ? arr[0].permissions : []);
                } else {
                    setPermissions([]);
                }
            })
            .catch((error) => {
                setSnackBarMessage('Failed to fetch permissions');
                setSnackbarSeverity('error');
                setSnackBarOpen(true);
                setPermissions([]);
            });
    };

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        if (Object.keys(user).length === 0) {
            navigate('/');
        } else {
            getPermissions(user.Email);
        }
    }, [navigate]);

    const CustomTableRow = withStyles({
        root: {
            background: '#E6E9FF !important',
            height: '3.5rem',
            width: '4.2rem'
        }
    })(TableRow);

    useEffect(() => {
    if (shouldOpenForm && selectedCandidate && formMode) {
        setFormOpen(true);
        setShouldOpenForm(false);
    }
}, [shouldOpenForm, selectedCandidate, formMode]);

    const getCandidateList = async () => {
        dispatch(AppActions.showLoader());

        try {
            const res = await getCandidates(
                page, limit, searchString, filterDesignation, parseDate(filterStartJoinDate),parseDate(filterEndJoinDate), filterStatus,
                filterSelectedTasks,parseDate(filterStartOnboardingDate),parseDate(filterEndOnboardingDate),sortBy,sortValue
            );

            if (res?.statusCode === 200) {
                const data = res?.data || {};
                setCandidates(data.candidatesList || []);
                setRecordCount(data.totalCount || 0);
            } else {
                throw new Error('Failed');
            }
        } catch (error) {
            setSnackBarMessage('Failed to retrieve candidates.');
            setSnackbarSeverity('error');
            setSnackBarOpen(true);
            setCandidates([]);
        }finally {
            dispatch(AppActions.hideLoader());
        }
    };

    const handleDownloadCandidatesReport = async () => {
        dispatch(AppActions.showLoader());

        try {
            const blob  = await downloadCandidatesReport(
                searchString, filterDesignation, parseDate(filterStartJoinDate),parseDate(filterEndJoinDate), filterStatus,
                filterSelectedTasks,parseDate(filterStartOnboardingDate),parseDate(filterEndOnboardingDate),sortBy,sortValue
            );

            const fileBlob = new Blob([blob], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const now = new Date();
            const timestamp = `${now.getFullYear()}-${(now.getMonth()+1).toString().padStart(2,'0')}-${now.getDate().toString().padStart(2,'0')}_` +
            `${now.getHours().toString().padStart(2,'0')}-${now.getMinutes().toString().padStart(2,'0')}-${now.getSeconds().toString().padStart(2,'0')}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download',`Onboarding_Report_${timestamp}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            setSnackBarMessage('Report downloaded successfully.');
            setSnackbarSeverity('success');
            setSnackBarOpen(true);
        } catch (error) {
            setSnackBarMessage('Failed to download report. Please try again.');
            setSnackbarSeverity('error');
            setSnackBarOpen(true);
        } finally {
            dispatch(AppActions.hideLoader());
        }
    };

    const fetchDesignationLists = async () => {
        try {
            const res = await getAllBillingRoles();
            setDesignationList(res?.data || []);
        } catch (error) {
            setDesignationList([]);
        }
    }

    const fetchTaskLists = async () => {
        try {
            const res = await getTaskList();
            let tasks = res?.data.data || [];
            if (
                tasks.length >= 2 &&
                tasks[0].name === "Assign a Laptop" &&
                tasks[1].name === "Create an Email Account"
            ) {
                [tasks[0], tasks[1]] = [tasks[1], tasks[0]];
            }
            setTaskList(tasks);
        } catch (error) {
            setTaskList([]);
        }
    };

    useEffect(() => {
        dispatch(AppActions.showLoader());
        dispatch(AppActions.toggleSnackBarClose());
        fetchTaskLists();
        fetchDesignationLists();
    }, []);

    useEffect(() => {
        getCandidateList();
        setPage(0);
    }, [searchString,sortBy,sortValue]);

    useEffect(() => {
        getCandidateList();
    }, [page, limit]);

    const handlePageChange = (event: any, newPage: number): void => {
        setPage(newPage);
    };

    const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
        setPage(0);
        setLimit(parseInt(event.target.value));
    };

    useEffect(() => {
        if (isFilterCleared) {
            getCandidateList();
        }
        setIsFilterCleared(false);
    }, [filterJoinDateChanged,filterOnboardingDateChanged, filterDesignation,filterSelectedTasks, filterStatus]);

    useEffect(() => {
        if (filterJoinDateChanged || filterOnboardingDateChanged || !(!filterDesignation && !filterStatus) || filterSelectedTasks.length>0) {
            setIsFilterDisabled(false);
        }
    }, [filterJoinDateChanged,filterOnboardingDateChanged, filterDesignation,filterSelectedTasks, filterStatus]);

    const handleReset = () => {
        joinDateRef.current?.setStartDate(new Date());
        joinDateRef.current?.setEndDate(new Date());
        onboardingDateRef.current?.setStartDate(new Date());
        onboardingDateRef.current?.setEndDate(new Date());
        setFilterStartJoinDate('');
        setFilterEndJoinDate('');
        setFilterJoinDateChanged(false);
        setFilterStartOnboardingDate('');
        setFilterEndOnboardingDate('');
        setFilterOnboardingDateChanged(false);
        setFilterSelectedTasks([]);
        setResetKey(prev => prev + 1);
    };

const handleEditCandidate = async (candidateId: number) => {
    try {
        dispatch(AppActions.showLoader());
        
        // Reset form state before opening edit mode
        setFormOpen(false);
        setSelectedCandidate(undefined);
        
        const response = await getCandidateById(candidateId);
        
        if (response?.data?.statusCode === 200) {
            // Small delay to ensure form is properly reset
            setTimeout(() => {
                setSelectedCandidate(response.data.data);
                setFormMode('edit');
                setFormOpen(true);
            }, 100);
        } else {
            handleSnackbarMessage('Failed to load candidate details for editing', 'error');
        }
    } catch (error) {
        
        handleSnackbarMessage('Failed to load candidate details for editing', 'error');
    } finally {
        dispatch(AppActions.hideLoader());
    }
};
    const onClear = () => {
        setFilterDesignation('');
        setFilterStatus('');
        handleReset();
        setPage(0);
        setIsFilterCleared(true);
        setIsFilterDisabled(true);
    }

    const onFilter = () => {
        setPage(0);
        getCandidateList();
    };

    useEffect(() => {
        if (!open || !snackBarOpen) {
            getCandidateList();
        }
    }, [open, snackBarOpen,]);

   function convertToDDMMYYYY(dateStr: string): string {
    // Check if dateStr is null, undefined, or empty
    if (!dateStr) {
        return '—'; // or return '' for empty string
    }
    
    const [year, month, day] = dateStr.split('-');
    return `${day}/${month}/${year}`;
}
    const getInitSettings = () => ({
        autoUpdateInput: false,
        locale: {
            format: 'DD/MM/YYYY',
        },
        showDropdowns: false,
        autoApply: false,
        alwaysShowCalendars: true,
    });

    const applyCurrentDate = async (event, picker) => {
        return Promise.resolve();
    };

    const handleSortToggle = (column: string) => {
        if (sortBy === column) {
            if (sortValue === 'desc') {
            setSortBy('');
            setSortValue('');
            } else {
            setSortValue(prev => (prev === 'asc' ? 'desc' : 'asc'));
            }
        } else {
            setSortBy(column);
            setSortValue('asc');
        }
    };

    function capitalize(str) {
        if (!str) return "";
        const formatted = str.replace(/_/g, " ");
        return formatted.charAt(0).toUpperCase() + formatted.slice(1).toLowerCase();
    }

    return (
        <>
            <Grid>
                <Grid container sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
                    <Grid item>
                        <Typography
                            style={{
                                marginLeft: '0px',
                                fontWeight: '700',
                                fontSize: '16px',
                                fontFamily:
                                    'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
                            }}
                        >
                            <span
                                style={{
                                    cursor: 'pointer',
                                    marginRight: '3px'
                                }}
                                onClick={() => {
                                    navigate('/employee-onboarding');
                                }}
                            >
                                Employee Onboarding
                            </span>
                        </Typography>
                        <Typography variant="subtitle2"></Typography>
                    </Grid>
                    <Grid item>
                        {permissions.some(
                            (perm) => perm.name === 'Download Report' && perm.value === true
                        ) && (
                            <Button
                                sx={{
                                    mt: { xs: 2, md: 0 },
                                    mr:2 ,
                                    fontSize: '11px',
                                    fontWeight: 'normal'
                                }}
                                variant="contained"
                                style={{ height: '1.75rem' }}
                                startIcon={<DownloadIcon fontSize="small" />}
                                onClick={handleDownloadCandidatesReport}
                            >
                                Download Report
                            </Button>
                        )}

                        {permissions.some(
                            (perm) => perm.name === 'Add Candidate' && perm.value === true
                        ) && (
                            <Button
                                sx={{
                                    mt: { xs: 2, md: 0 },
                                    fontSize: '11px',
                                    fontWeight: 'normal'
                                }}
                                variant="contained"
                                style={{ height: '1.75rem' }}
                                startIcon={<AddTwoToneIcon fontSize="small" />}
                                onClick={handleCreateCandidate}
                            >
                                Add New Candidate
                            </Button>
                        )}
                    </Grid>
                </Grid>
                <Card>
                    <Grid sx={{ m: 2 ,mb:1 }}>
                        <TextField
                            sx={{ width: 320, mr: 2 }}
                            size="small"
                            placeholder="Candidate Name"
                            InputProps={{
                                style: { fontSize: '13px', height: '2.07rem' },
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon
                                            sx={{ color: '#d3d3d3' }}
                                            style={{ fontSize: '15px' }}
                                        />
                                    </InputAdornment>
                                )
                            }}
                            inputProps={{
                                maxLength: 255
                            }}
                            value={searchString}
                            onChange={(e) => {
                                setSearchString(e.target.value);
                            }}
                        />
                        <Button
                            sx={{
                                mt: { xs: 2, md: 0 },
                                color: `${!toggleFilter && 'gray'}`
                            }}
                            variant="outlined"
                            startIcon={<FilterListIcon style={{ fontSize: '15px' }} />}
                            style={{ height: '2.07rem', fontSize: '12px' }}
                            onClick={() => {
                                setToggleFilter(!toggleFilter);
                            }}
                        >
                            Filters
                        </Button>
                    </Grid>
                    {toggleFilter && (
                        <Grid px={2} pb={2} style={{ margin: 0 }}>
                            <Grid
                                container
                                spacing={1.5}
                                style={{
                                    paddingTop: 2,
                                    paddingBottom: 2,
                                    justifyContent: 'between'
                                }}
                            >
                                <Grid item xs>
                                    <FormControl fullWidth >
                                        <DateRangePicker
                                            ref={joinDateRef}
                                            initialSettings={getInitSettings()}
                                            onApply={(event, picker) => {
                                                if (!picker.startDate || !picker.endDate || !picker.startDate.isValid() || !picker.endDate.isValid()) {
                                                    return;
                                                }

                                                applyCurrentDate(event, picker).then(() => {
                                                     const sDate = moment(picker.startDate).startOf('day').format('DD/MM/YYYY');
                                                    const eDate = moment(picker.endDate).endOf('day').format('DD/MM/YYYY');
                                                    setFilterStartJoinDate(sDate);
                                                    setFilterEndJoinDate(eDate);
                                                    setFilterJoinDateChanged(true);
                                                });
                                            }}

                                            onCancel={() => {
                                                handleReset();
                                            }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                                <TextField
                                                    placeholder="Joining Date Range"
                                                    value={filterJoinDateChanged ? `${filterStartJoinDate} - ${filterEndJoinDate}` : ''}
                                                    id="joinDate"
                                                    fullWidth
                                                    size="small"
                                                    sx={{
                                                        paddingTop: '7.5px',
                                                        '& .MuiInputBase-input': {
                                                            height: '33px',
                                                            boxSizing: 'border-box',
                                                            fontSize: { md: '12px'},
                                                            '&::placeholder': {
                                                                fontSize: { md: '12px'},
                                                            },
                                                        },
                                                    }}

                                                />
                                                <CalendarTodayIcon
                                                    style={{
                                                        position: 'absolute',
                                                        top: '36%',
                                                        right: '4%',
                                                        marginTop: '2px',
                                                        fontSize: '16px',
                                                    }}
                                                />
                                            </div>
                                        </DateRangePicker>
                                    </FormControl>
                                </Grid>

                                <Grid item xs>
                                    <FormControl fullWidth>
                                        <Select
                                            sx={{ mt: 1 }}
                                            style={{
                                                fontSize: '12px',
                                                height: '2.07rem'
                                            }}
                                            fullWidth
                                            value={filterDesignation || ' '}
                                            onChange={(e) => {
                                                setFilterDesignation(e.target.value);
                                            }}
                                            onClose={() => setSearchText('')}
                                            displayEmpty
                                        >
                                            <ListSubheader>
                                                <TextField
                                                    autoFocus
                                                    placeholder="Type to search..."
                                                    size="small"
                                                    fullWidth
                                                    value={searchText}
                                                    onChange={(e) => setSearchText(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key !== 'Escape') {
                                                            e.stopPropagation();
                                                        }
                                                    }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <SearchIcon fontSize="small" />
                                                            </InputAdornment>
                                                        ),
                                                        style: {
                                                            fontSize: '12px',
                                                            height: '32px',
                                                        },
                                                    }}
                                                />
                                            </ListSubheader>
                                            <MenuItem
                                                style={{ display: 'none' }}
                                                value=" "
                                                disabled
                                                hidden
                                            >
                                                <span style={{ color: '#a4a9b7' }}>
                                                    Designation
                                                </span>
                                            </MenuItem>
                                            {filteredDesignations.map((item) => {
                                                return (
                                                    <MenuItem value={item.name} key={item.id}>
                                                        {item.name}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs>
                                    <FormControl fullWidth>
                                        <Select
                                            sx={{ mt: 1 , minWidth: 150}}
                                            id="status"
                                            style={{
                                                fontSize: '12px',
                                                height: '2.07rem'
                                            }}
                                            fullWidth
                                            size="small"
                                            value={filterStatus || 'Status'}
                                            onChange={(e) => {
                                                setFilterStatus(e.target.value);
                                            }}
                                        >
                                            <MenuItem
                                                style={{ display: 'none' }}
                                                value="Status"
                                                disabled
                                                hidden
                                            >
                                                <span style={{ color: '#a4a9b7' }}>
                                                    Overall Onboarding Status
                                                </span>
                                            </MenuItem>
                                            {Object.entries(CandidateStatus).map(([key, label]) => (
                                                <MenuItem value={key} key={key}>
                                                    {label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        
                                    </FormControl>
                                </Grid>

                                <Grid item xs>
                                    <FormControl fullWidth>
                                        <Select
                                        multiple
                                        sx={{ mt: 1 ,maxWidth:'309px'}}
                                        style={{
                                            fontSize: "12px",
                                            height: "2.07rem",
                                        }}
                                        fullWidth
                                        value={filterSelectedTasks}
                                        onChange={(e) => {
                                            const value = typeof e.target.value === "string" ? e.target.value.split(",") : e.target.value;
                                            setFilterSelectedTasks(value);
                                        }}
                                        onClose={() => setSearchText("")}
                                        displayEmpty
                                        renderValue={(selected) => {
                                            if (selected.length === 0) {
                                            return <span style={{ color: "#a4a9b7" }}>Tasks</span>;
                                            }
                                            return (
                                            <Box
                                                sx={{
                                                display: "flex",
                                                overflowX: "auto",        
                                                gap: 0.5,
                                                maxWidth: "100%",          
                                                "&::-webkit-scrollbar": { display: "none" },
                                                scrollbarWidth: "none",
                                                msOverflowStyle: "none",
                                                whiteSpace: "nowrap",
                                                }}
                                            >
                                                {selected.map((id) => {
                                                    const task = taskList.find((t) => t.id === id);
                                                    return (
                                                        <Box
                                                            key={id}
                                                            sx={{
                                                                flexShrink: 0,           
                                                                fontSize: "12px",
                                                                padding: "2px 6px",
                                                                backgroundColor: "#f0f0f0",
                                                                borderRadius: "4px",
                                                            }}
                                                        >
                                                            {task?.name}
                                                        </Box>
                                                    );
                                                })}
                                            </Box>
                                            );
                                        }}
                                        >
                                        {/* Search Field */}
                                        <ListSubheader>
                                            <TextField
                                            autoFocus
                                            placeholder="Type to search..."
                                            size="small"
                                            fullWidth
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key !== "Escape") {
                                                e.stopPropagation();
                                                }
                                            }}
                                            InputProps={{
                                                startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon fontSize="small" />
                                                </InputAdornment>
                                                ),
                                                style: {
                                                fontSize: "12px",
                                                height: "32px",
                                                },
                                            }}
                                            />
                                        </ListSubheader>

                                        {/* Options */}
                                        {Object.values(taskList)
                                            .filter((task) => task.name.toLowerCase().includes(searchText.toLowerCase()))
                                            .map((task) => (
                                            <MenuItem key={task.id} value={task.id}>
                                                <Checkbox checked={filterSelectedTasks.includes(task.id)} />
                                                {task.name}
                                            </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs>
                                    <FormControl fullWidth >
                                        <DateRangePicker
                                            ref={onboardingDateRef}
                                            initialSettings={getInitSettings()}
                                            onApply={(event, picker) => {
                                                if (!picker.startDate || !picker.endDate || !picker.startDate.isValid() || !picker.endDate.isValid()) {
                                                    return;
                                                }

                                                applyCurrentDate(event, picker).then(() => {
                                                    const sDate = moment(picker.startDate).startOf('day').format('DD/MM/YYYY');
                                                    const eDate = moment(picker.endDate).endOf('day').format('DD/MM/YYYY');
                                                    setFilterStartOnboardingDate(sDate);
                                                    setFilterEndOnboardingDate(eDate);
                                                    setFilterOnboardingDateChanged(true);
                                                });
                                            }}

                                            onCancel={() => {
                                                handleReset();
                                            }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                                <TextField
                                                    placeholder="Onboarding Date Range"
                                                    value={filterOnboardingDateChanged ? `${filterStartOnboardingDate} - ${filterEndOnboardingDate}` : ''}
                                                    id="onboardingDate"
                                                    fullWidth
                                                    size="small"
                                                    sx={{
                                                        paddingTop: '7.5px',
                                                        '& .MuiInputBase-input': {
                                                            height: '33px',
                                                            boxSizing: 'border-box',
                                                            fontSize: { md: '12px'},
                                                            '&::placeholder': {
                                                               fontSize: { md: '12px'},
                                                            },
                                                        },
                                                    }}

                                                />
                                                <CalendarTodayIcon
                                                    style={{
                                                        position: 'absolute',
                                                        top: '36%',
                                                        right: '4%',
                                                        marginTop: '2px',
                                                        fontSize: '16px',
                                                    }}
                                                />
                                            </div>
                                        </DateRangePicker>
                                    </FormControl>
                                </Grid>

                                <Grid
                                    item
                                    xs={9}
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        marginLeft: 'auto'
                                    }}
                                >
                                    <Button
                                        variant="outlined"
                                        style={{
                                            height: '1.75rem',
                                            fontSize: '12px'
                                        }}
                                        id="filterClear"
                                        disabled={isFilterDisabled}
                                        onClick={() => onClear()}
                                    >
                                        Clear
                                    </Button>
                                    <Button
                                        id="filterSubmit"
                                        variant="outlined"
                                        type="button"
                                        style={{
                                            height: '1.75rem',
                                            fontSize: '12px',
                                            marginLeft: '1rem'
                                        }}
                                        onClick={() => onFilter()}
                                        disabled={isFilterDisabled}
                                    >
                                        Filter
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                    <Divider />
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <CustomTableRow>
                                    <TableHeaderCell content="Candidate Name" smallFont sort
                                        sortType={sortBy === 'candidatename' ? sortType : undefined}  
                                        setSortType={() => handleSortToggle('candidatename')}
                                    />
                                    <TableHeaderCell content="Designation" smallFont />
                                    <TableHeaderCell content="Employment Type" smallFont />
                                    <TableHeaderCell content="Expected Joining Date" smallFont />
                                    <TableHeaderCell content="Onboarding Start Date" smallFont sort 
                                        sortType={sortBy === 'onboardingstartdate' ? sortType : undefined}  
                                        setSortType={() => handleSortToggle('onboardingstartdate')}
                                    />
                                    <TableHeaderCell content="Onboarding End Date" smallFont sort
                                        sortType={sortBy === 'onboardingenddate' ? sortType : undefined}  
                                        setSortType={() => handleSortToggle('onboardingenddate')}
                                    />
                                    <TableHeaderCell content="Pre-Onboarding Status" smallFont />
                                    <TableHeaderCell content="Post-Onboarding Status" smallFont />
                                    <TableHeaderCell content="Overall Onboarding Status" smallFont />
                                    <TableHeaderCell content="Tasks" smallFont justifyContent />
                                    <TableHeaderCell content="Sub Tasks" smallFont justifyContent/>
                                    <TableHeaderCell content="Current Task Status" smallFont />
                                    <TableHeaderCell
                                        content="Action"
                                        smallFont
                                        sticky
                                        justifyContent
                                        width="110px"
                                    />
                                </CustomTableRow>
                            </TableHead>
                            <TableBody>
                                {candidates.length !== 0 &&
                                    candidates.map((item) => {
                                        return (
                                            <React.Fragment key={item.id}>
                                                <TableRow key={item.id}>
                                                    <TableColumnCell>
                                                        <Box display="flex" alignItems="center" gap={1}>
                                                            
                                                            <Button
                                                                sx={{
                                                                    mt: { xs: 2, md: 0 },
                                                                    p: 0,
                                                                    fontSize: '11px',
                                                                    fontWeight: 'normal',
                                                                    height: '20px',
                                                                    width: '20px',
                                                                    minWidth: 'unset',
                                                                    borderRadius: '4px',
                                                                    cursor: 'pointer',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                }}
                                                                disabled={!item.tasks || item.tasks.length === 0}
                                                                onClick={() => setExpandedCandidateId(prev => prev === item?.id ? null : item?.id)}
                                                                variant="contained"
                                                                >
                                                                {expandedCandidateId === item?.id ? (
                                                                    <HorizontalRuleIcon  sx={{ fontSize: '15px'}} />
                                                                ) : (
                                                                    <AddTwoToneIcon fontSize="small" sx={{ fontSize: '15px' }} />
                                                                )}
                                                            </Button>

                                                            <Typography
                                                                paddingBottom="0.25rem"
                                                                paddingTop="0.5rem"
                                                                variant="body2"
                                                                gutterBottom
                                                                style={{ fontSize: '11px' }}
                                                                noWrap
                                                            >
                                                                {item?.name}
                                                            </Typography>
                                                        </Box>
                                                    </TableColumnCell>  
                                                     <TableColumnCell>
                                                        <Typography
                                                            paddingBottom="0.25rem"
                                                            paddingTop="0.5rem"
                                                            variant="body2"
                                                            style={{ fontSize: '11px' }}
                                                            gutterBottom
                                                            noWrap
                                                        >
                                                            {item?.designation}
                                                        </Typography>
                                                    </TableColumnCell>
                                                    <TableColumnCell>
                                                        <Typography
                                                            paddingBottom="0.25rem"
                                                            paddingTop="0.5rem"
                                                            variant="body2"
                                                            style={{ fontSize: '11px' }}
                                                            gutterBottom
                                                            noWrap
                                                        >
                                                            {capitalize(item?.employeeType)}
                                                        </Typography>
                                                    </TableColumnCell>                                            
                                                    <TableColumnCell>
                                                        <Typography
                                                            paddingBottom="0.25rem"
                                                            paddingTop="0.5rem"
                                                            paddingRight="2rem"
                                                            variant="body2"
                                                            style={{ fontSize: '11px' }}
                                                            gutterBottom
                                                            noWrap
                                                        >
                                                            {item?.expectedJoinDate ? convertToDDMMYYYY(item.expectedJoinDate) : '—'}
                                                        </Typography>
                                                    </TableColumnCell>
                                                    <TableColumnCell >
                                                        <Typography
                                                            paddingBottom="0.25rem"
                                                            paddingTop="0.5rem"
                                                            paddingRight="2rem"
                                                            variant="body2"
                                                            style={{ fontSize: '11px' ,textAlign: 'center'}}
                                                            gutterBottom
                                                            noWrap
                                                        >
                                                            {item?.onboardStartDate ? convertToDDMMYYYY(item.onboardStartDate) : '—'}
                                                        </Typography>
                                                    </TableColumnCell>
                                                    <TableColumnCell>
                                                        <Typography
                                                            paddingBottom="0.25rem"
                                                            paddingTop="0.5rem"
                                                            paddingRight="2rem"
                                                            variant="body2"
                                                            style={{ fontSize: '11px' ,textAlign: 'center'}}
                                                            gutterBottom
                                                            noWrap
                                                        >
                                                            {item?.onboardEndDate ? convertToDDMMYYYY(item.onboardEndDate) : '—'}
                                                        </Typography>
                                                    </TableColumnCell>
                                                    <TableColumnCell>
                                                        <Typography
                                                            paddingBottom="0.25rem"
                                                            paddingTop="0.5rem"
                                                            variant="body2"
                                                            style={{ fontSize: '11px' ,textAlign: 'center'}}
                                                            gutterBottom
                                                            noWrap
                                                        >
                                                            {CandidateStatus[item?.preOnboardStatus as keyof typeof CandidateStatus] || CandidateStatus.PENDING}
                                                        </Typography>
                                                    </TableColumnCell>
                                                    <TableColumnCell>
                                                    <Typography
                                                        paddingBottom="0.25rem"
                                                        paddingTop="0.5rem"
                                                        variant="body2"
                                                        style={{ fontSize: '11px', textAlign: 'center' }}
                                                        gutterBottom
                                                        noWrap
                                                        >
                                                            {CandidateStatus[item?.postOnboardStatus as keyof typeof CandidateStatus] || CandidateStatus.PENDING}
                                                        </Typography>
                                                    </TableColumnCell>
                                                    <TableColumnCell>
                                                        <Typography
                                                            paddingBottom="0.25rem"
                                                            paddingTop="0.5rem"
                                                            variant="body2"
                                                            style={{ fontSize: '11px' ,textAlign: 'center'}}
                                                            gutterBottom
                                                            noWrap
                                                        >
                                                            {CandidateStatus[item?.overallStatus as keyof typeof CandidateStatus] || CandidateStatus.PENDING}
                                                        </Typography>
                                                    </TableColumnCell>
                                                    {[...Array(3)].map((_, i) => (
                                                        <TableColumnCell key={`placeholder-${i}`}>
                                                            <Typography
                                                                paddingBottom="0.25rem"
                                                                paddingTop="0.5rem"
                                                                variant="body2"
                                                                style={{ fontSize: '11px' ,textAlign: 'center'}}
                                                                gutterBottom
                                                                noWrap
                                                            >
                                                                {''}
                                                            </Typography>
                                                        </TableColumnCell>
                                                    ))}                                            
                                                    <TableColumnCell sticky justifyContent>
                                                        <Box
                                                            display="flex"
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            gap={1}
                                                            sx={{
                                                                maxWidth: '50px',
                                                                width: '50px',
                                                                pl: 0,
                                                                pr: 0,
                                                            }}
                                                        >
                                                            {permissions.some(
                                                                (perm) =>
                                                                    perm.name === 'View Candidates' &&
                                                                    perm.value === true
                                                            ) && (
                                                                    <Tooltip title="View Candidate" placement="top">
                                                                        <IconButton
                                                                            onClick={() => handleViewCandidate(item.id)}
                                                                            size="small"
                                                                        >
                                                                            <VisibilityIcon
                                                                                style={{
                                                                                    fontSize: '18px',
                                                                                    cursor: 'pointer',
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}


                                                            {permissions.some(
                                                                (perm) =>
                                                                    perm.name === 'Edit Candidate' &&
                                                                    perm.value === true
                                                            ) && (
                                                                    <Tooltip title="Edit Candidate" placement="top">
                                                                        <IconButton
                                                                        onClick={() => handleEditCandidate(item.id)}
                                                                            size="small"
                                                                        >
                                                                            <EditIcon
                                                                                style={{
                                                                                    fontSize: '18px',
                                                                                    cursor: 'pointer',
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}

                                                            {permissions.some(
                                                                (perm) =>
                                                                    perm.name === 'View To Do List' && perm.value === true
                                                            ) && (
                                                                    <Tooltip title="View To Do List" placement="top">
                                                                        <IconButton
                                                                        onClick={() => {
                                                                            NavigateToToDoListPage(item.id);
                                                                        }}

                                                                            size="small"
                                                                        >
                                                                            <ChecklistIcon
                                                                                style={{
                                                                                    fontSize: '18px',
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}

                                                        </Box>
                                                    </TableColumnCell>
                                                </TableRow>
                                                {/* Tasks + SubTasks rows */}
                                                {expandedCandidateId === item.id &&
                                                (() => {
                                                    const tasks = [...item.tasks];
                                                    if (
                                                    tasks.length >= 2 &&
                                                    tasks[0].name === "Assign a Laptop" &&
                                                    tasks[1].name === "Create an Email Account"
                                                    ) {
                                                    [tasks[0], tasks[1]] = [tasks[1], tasks[0]];
                                                    }
                                                    return tasks.map((task) => (
                                                    <React.Fragment key={task.id}>
                                                    {/* Task Row */}
                                                    <TableRow>
                                                        {/* Placeholders */}
                                                        {[...Array(9)].map((_, i) => (
                                                        <TableColumnCell key={`task-empty-${i}`}>
                                                            <Typography
                                                            paddingBottom="0.25rem"
                                                            paddingTop="0.5rem"
                                                            variant="body2"
                                                            style={{ fontSize: '11px', textAlign: 'center' }}
                                                            gutterBottom
                                                            noWrap
                                                            >
                                                            {''}
                                                            </Typography>
                                                        </TableColumnCell>
                                                        ))}

                                                        <TableColumnCell>
                                                        <Box display="flex" alignItems="center" gap={1}>
                                                            {task.subTasks.length === 0 ? (
                                                                <Box sx={{ width: 23, height: 15 ,color:'#ffffff'}} />
                                                            ) : (
                                                                <Button
                                                                    sx={{
                                                                        mt: { xs: 2, md: 0 },
                                                                        p: 0,
                                                                        fontSize: '11px',
                                                                        fontWeight: 'normal',
                                                                        height: '20px',
                                                                        width: '20px',
                                                                        minWidth: 'unset',
                                                                        borderRadius: '4px',
                                                                        cursor: 'pointer',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                    }}
                                                                    onClick={() =>
                                                                        setExpandedTaskId((prev) => (prev === task.id ? null : task.id))
                                                                    }
                                                                    variant="contained"
                                                                    disabled={task.subTasks.length === 0}
                                                                    >
                                                                    {expandedTaskId === task.id ? (
                                                                        <HorizontalRuleIcon sx={{ fontSize: '15px' }} />
                                                                    ) : (
                                                                        <AddTwoToneIcon fontSize="small" sx={{ fontSize: '15px' }} />
                                                                    )}
                                                                </Button>
                                                            )}

                                                            <Typography
                                                            paddingBottom="0.25rem"
                                                            paddingTop="0.5rem"
                                                            variant="body2"
                                                            style={{ fontSize: '11px' }}
                                                            gutterBottom
                                                            noWrap
                                                            >
                                                            {task.name}
                                                            </Typography>
                                                        </Box>
                                                        </TableColumnCell>

                                                        <TableColumnCell>
                                                        <Typography
                                                            paddingBottom="0.25rem"
                                                            paddingTop="0.5rem"
                                                            variant="body2"
                                                            style={{ fontSize: '11px', textAlign: 'center' }}
                                                            gutterBottom
                                                            noWrap
                                                        >
                                                            {''}
                                                        </Typography>
                                                        </TableColumnCell>

                                                        <TableColumnCell>
                                                        <Typography
                                                            paddingBottom="0.25rem"
                                                            paddingTop="0.5rem"
                                                            variant="body2"
                                                            style={{ fontSize: '11px' , textAlign: 'center' }}
                                                            gutterBottom
                                                            noWrap
                                                        >
                                                            {TaskStatus[task?.status as keyof typeof TaskStatus]}
                                                        </Typography>
                                                        </TableColumnCell>

                                                        <TableColumnCell sticky justifyContent>
                                                        <Box
                                                            display="flex"
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            gap={1}
                                                            sx={{
                                                            maxWidth: '50px',
                                                            width: '50px',
                                                            pl: 0,
                                                            pr: 0,
                                                            }}
                                                        />
                                                        </TableColumnCell>
                                                    </TableRow>

                                                    {/* SubTasks Rows */}
                                                    {expandedTaskId === task.id &&
                                                        task?.subTasks?.length > 0 &&
                                                        task.subTasks.slice()
                                                        .sort((a, b) => a.name.localeCompare(b.name))
                                                        .map((subTask) => (
                                                        <TableRow key={subTask.id}>
                                                            {[...Array(10)].map((_, i) => (
                                                            <TableColumnCell key={`subtask-empty-${task.id}-${i}`}>
                                                                <Typography
                                                                paddingBottom="0.25rem"
                                                                paddingTop="0.5rem"
                                                                variant="body2"
                                                                style={{ fontSize: '11px', textAlign: 'center' }}
                                                                gutterBottom
                                                                noWrap
                                                                >
                                                                {''}
                                                                </Typography>
                                                            </TableColumnCell>
                                                            ))}

                                                            <TableColumnCell>
                                                            <Typography
                                                                paddingBottom="0.25rem"
                                                                paddingTop="0.5rem"
                                                                variant="body2"
                                                                style={{ fontSize: '11px' }}
                                                                gutterBottom
                                                                noWrap
                                                            >
                                                                {subTask.name}
                                                            </Typography>
                                                            </TableColumnCell>

                                                            <TableColumnCell>
                                                            <Typography
                                                                paddingBottom="0.25rem"
                                                                paddingTop="0.5rem"
                                                                variant="body2"
                                                                style={{ fontSize: '11px' , textAlign: 'center' }}
                                                                gutterBottom
                                                                noWrap
                                                            >
                                                                {TaskStatus[subTask?.status as keyof typeof TaskStatus]}
                                                            </Typography>
                                                            </TableColumnCell>

                                                            <TableColumnCell sticky justifyContent>
                                                            <Box
                                                                display="flex"
                                                                alignItems="center"
                                                                justifyContent="center"
                                                                gap={1}
                                                                sx={{
                                                                maxWidth: '50px',
                                                                width: '50px',
                                                                pl: 0,
                                                                pr: 0,
                                                                }}
                                                            />
                                                            </TableColumnCell>
                                                        </TableRow>
                                                        ))}
                                                    </React.Fragment>
                                                    ));
                                                })()
                                                }                                              
                                            </React.Fragment>                                           
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {candidates?.length === 0 && (
                        <Typography
                            style={{
                                fontSize: '15px',
                                fontWeight: 'bold',
                                margin: '1rem',
                                textAlign: 'center'
                            }}
                            variant="body2"
                        >
                            No records found
                        </Typography>
                    )}
                    <Box p={2}>
                        <TablePagination
                            sx={{
                                fontSize: '12px',
                                '.MuiTablePagination-displayedRows': {
                                    fontSize: '12px'
                                },
                                '.MuiTablePagination-selectLabel': {
                                    fontSize: '12px'
                                }
                            }}
                            component="div"
                            count={recordCount}
                            onPageChange={handlePageChange}
                            onRowsPerPageChange={handleLimitChange}
                            page={page}
                            rowsPerPage={limit}
                            rowsPerPageOptions={[10, 20, 30, 40, 50]}
                        />
                    </Box>
                </Card>

                <SnackBar
                    snackBarOpen={snackBarOpen}
                    setSnackBarOpen={setSnackBarOpen}
                    snackBarMessage={snackBarMessage}
                    snackbarSeverity={snackbarSeverity}
                />

                 <CandidateForm
                    open={formOpen}
                    onClose={() => setFormOpen(false)}
                    mode={formMode}
                    candidate={selectedCandidate}
                    onSuccess={handleFormSuccess}
                    onError={handleFormError}
                />
            </Grid>
        </>
    );
};


export default ViewOnboarding;
